// extracted by mini-css-extract-plugin
module.exports = {"link":"_93444fe79c--link--aea1A","link_redesign":"_93444fe79c--link_redesign--3S9SP"};